import cookiebanner from './cookie-banner.vue'
import cookiesettings from './cookie-settings.vue'
import cookieShared from './cookie-shared.js'
import Api from '../../lib/api.js'
import { LANGUAGE_STRINGS, CURRENT_LANGUAGE } from '../../lib/translations.js'
import constants from '../../lib/constants.js'
const { COOKIE_INFO, COOKIE_VERSION } = constants()

export default {
  mixins: [cookieShared],

  components: {
    cookiebanner,
    cookiesettings
  },

  data () {
    return {
      cookieName: 'or-cookieT',
      showSettings: false,
      showCookieApp: true,
      settingsCookie: '',
      version: 0,
      data: {},
      items: {},
      cookiePageLink: ''
    }
  },

  ready () {
    this.settingsCookie = this.getPreviousSettings(this.cookieName)
    Api.fetchLanguageFile(this.onLanguageLoaded)
    this.fetchEmbeddedCookieInfo()
  },

  events: {
    'toggleSettings' () {
      this.showSettings = !this.showSettings
    },

    'saveSettings' () {
      this.settingsCookie = this.createSettingsCookieString(this.items)
      this.closeAndSave(this.links)
    },

    'agree' () {
      this.settingsCookie = this.createSettingsCookieString(this.items, true)
      // because we are agreeing to all cookies, use this.items instead of this.links
      this.closeAndSave(this.items)
    },

    'show-app' () {
      this.showSettings = !this.showCookieApp
      this.showCookieApp = !this.showCookieApp
    }
  },

  computed: {
    links () {
      return this.items.filter(item => {
        return item.value === true
      })
    }
  },

  methods: {
    fetchEmbeddedCookieInfo () {
      if (COOKIE_INFO) {
        this.data = JSON.parse(COOKIE_INFO)
        let version = COOKIE_VERSION

        if (!this.settingsCookie) {
          this.items = this.createItems(this.data)
        } else if (this.settingsCookie) {
          this.cookieVersion = this.checkCookieVersion(this.settingsCookie)
          this.items = this.createItemsWithSettings(this.settingsCookie, this.data)
          this.initializeCookies(this.links)
          this.showCookieApp = version !== this.checkCookieVersion(this.settingsCookie)
        }
      }
    },

    onLanguageLoaded (loaded, errorDetails, data) {
      if (loaded) {
        this.languageObj = data[0]
      } else {
        this.languageObj = LANGUAGE_STRINGS[CURRENT_LANGUAGE]
      }
      this.$broadcast('language-set', this.languageObj)
    },

    closeAndSave (links) {
      this.settingsCookie = this.addVersionToCookie(this.settingsCookie, COOKIE_VERSION)
      this.setCookie(this.cookieName, this.settingsCookie, 1095)
      this.initializeCookies(links)
      this.showSettings = false
      this.showCookieApp = false
    },

    checkCookieVersion (cookie) {
      var arr = cookie.split(',')
      var version = arr[arr.length - 1].split(':')[1]
      return version
    },

    createItems (data) {
      var items = []

      for (var property in data) {
        var obj = {'name': property, 'value': property === 'required', 'required': data[property].required, 'links': data[property].links}
        items.push(obj)
      }

      return items
    },

    createItemsWithSettings (settings, data) {
      var items = []
      var settingsArr = settings.split(',')
      var settingsObj = {}

      settingsArr.forEach(function (element) {
        var elementArr = element.split(':')
        settingsObj[[elementArr[0]]] = elementArr[1]
      })

      for (var property in data) {
        var value = settingsObj[property] ? (settingsObj[property] === 'true') : false
        var obj = {'name': property, 'value': value, 'required': data[property].required, 'links': data[property].links}
        items.push(obj)
      }

      return items
    },

    getPreviousSettings (cookieName) {
      var prevCookie = this.getCookie(cookieName)
      if (prevCookie) {
        return prevCookie
      } else {
        return false
      }
    },

    initializeCookies (data) {
      this.clearCookieScripts()
      var that = this

      data.forEach(function (linkList) {
        if (linkList.links) {
          linkList.links.forEach(function (link) {
            that.createLink(link)
          })
        }
      })
    },

    createLink (link) {
      var linkEl = document.createElement('script')
      linkEl.setAttribute('src', link)
      linkEl.className = 'or-cookie-script'
      document.head.appendChild(linkEl)
    },

    clearCookieScripts () {
      var cookieScripts = document.querySelectorAll('.or-cookie-script')

      for (var i = 0; i < cookieScripts.length; i++) {
        cookieScripts[i].remove()
      }
    },

    createSettingsCookieString (data, agreeToAll) {
      var str = ''

      data.forEach(function (element) {
        var settingsValue = agreeToAll === true ? true : element.value
        str += element.name + ':' + settingsValue + ','
      })

      str = str.slice(0, -1) // remove last comma
      return str
    },

    addVersionToCookie (cookie, version) {
      var cookieArr = cookie.split(',')
      if (cookieArr[cookieArr.length - 1].split(':')[0] === 'ver') {
        cookieArr.pop()
      }
      return (cookieArr.join()) + ',ver:' + version
    },

    setCookie (cname, cvalue, exdays) {
      var d = new Date()
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
      var expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    },

    getCookie (cname) {
      var name = cname + '='
      var decodedCookie = decodeURIComponent(document.cookie)
      var ca = decodedCookie.split(';')

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/kokuapp/cookieApp.js